module.exports = __webpack_public_path__ + "img/up-01.a122ee62.svg";